import { render, staticRenderFns } from "./DriveFolderDeleted.vue?vue&type=template&id=7875299f&scoped=true"
import script from "./DriveFolderDeleted.vue?vue&type=script&lang=js"
export * from "./DriveFolderDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7875299f",
  null
  
)

export default component.exports